import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { ServiceLocationsBadgeProps } from "./ServiceLocationsBadge.types"

const icon = faIcon({ name: "location-dot", style: "regular" })

export default function ServiceLocationsBadge(props: ServiceLocationsBadgeProps) {
    const { count, size = "md" } = props

    // Always rendered — shows "0" when the object has no service locations.
    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={`Locations\n${count}`}>
            {count}
        </Badge>
    )
}
